/**
 * Geometry shared by the canvas and the board thumbnails on the boards list. It lives apart from
 * `CanvasPage` so the list doesn't pull the (route-lazy) canvas in just to draw a preview.
 */

/** Fractions of a box are stored to 3 decimals: far finer than a pixel, a third of the bytes. */
export const round3 = (n: number) => Math.round(n * 1000) / 1000;

/**
 * Freehand points as a path, smoothed through the midpoints between them. Points are fractions of
 * a `w` by `h` box; the default scale of 1 leaves points that are already absolute untouched.
 */
export function inkPath(points: readonly number[], w = 1, h = 1): string {
  const n = Math.floor(points.length / 2);
  if (!n) return '';
  const px = (i: number) => round3(points[i * 2]! * w);
  const py = (i: number) => round3(points[i * 2 + 1]! * h);
  // A dot: a zero-length line still paints its round cap.
  if (n === 1) return `M${px(0)} ${py(0)}l0 0`;
  let d = `M${px(0)} ${py(0)}`;
  // Each point is a control point and the curve passes through the midpoints, which turns a
  // thinned pointer trail back into a smooth line.
  for (let i = 1; i < n - 1; i++) d += `Q${px(i)} ${py(i)} ${round3((px(i) + px(i + 1)) / 2)} ${round3((py(i) + py(i + 1)) / 2)}`;
  return `${d}L${px(n - 1)} ${py(n - 1)}`;
}
